/**
 * Packar upp base64-kodad zlib-data (Pythons `zlib.compress`) till bytes.
 *
 * Använder webbläsarens inbyggda `DecompressionStream('deflate')` — formatet
 * "deflate" i Compression Streams-standarden är just zlib (RFC 1950), så inget
 * extra bibliotek behövs. Används av kartkontrollens kartvy.
 *
 * @param {string} b64 Base64-sträng med zlib-komprimerad data.
 * @returns {Promise<Uint8Array>} De uppackade bytena.
 */
export async function inflateBase64(b64) {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('deflate'));
  return new Uint8Array(await new Response(stream).arrayBuffer());
}

export default inflateBase64;
